<div id="notaccess">
    <div class="maincontainer">
        <div class="bat">
            <img class="wing leftwing" 
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-wing.png">
            <img class="body"
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-body.png" alt="bat">
            <img class="wing rightwing"
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-wing.png">
        </div>
        <div class="bat">
            <img class="wing leftwing" 
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-wing.png">
            <img class="body"
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-body.png" alt="bat">
            <img class="wing rightwing"
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-wing.png">
        </div>
        <div class="bat">
            <img class="wing leftwing" 
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-wing.png">
            <img class="body"
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-body.png" alt="bat">
            <img class="wing rightwing"
                src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/bat-wing.png">
        </div>
        <img class="foregroundimg" src="https://aimieclouse.com/Media/Portfolio/Error403Forbidden/HauntedHouseForeground.png" alt="haunted house">
    </div>

    <h1 class="errorcode">ERROR 403</h1>
    <div class="errortext">This area is forbidden. Turn back now!</div>

    <!-- Back Button -->
    <div class="backbtn-container">
        <button class="backbtn" (click)="goBack()">⬅ Go Back</button>
    </div>
</div>
